import React from "react";
import { Size } from "src/utils/formUtils/getInputHeight";
import ATMFileUploader from "./ATMFileUploader";
import { ErrorMessage } from "formik";
import useFilePicker from "src/hooks/useFilePicker";
import { showToast } from "src/utils/showToaster";

type Props = {
  size?: Size;
  label?: string;
  required?: boolean;
  placeholder?: string;
  onSelect: (file: File | string) => void;
  selectedFile: any;
  name: string;
  accept?: string;
  disabled?: boolean;
};

const ATMFilePickerWrapper = ({
  name,
  size = "small",
  label = "",
  required = false,
  placeholder = "",
  onSelect,
  selectedFile,
  accept = "image/*",
  disabled,
}: Props) => {
  const { uploadFile, isLoading } = useFilePicker();

  const onSelectFilePicker = async (e: any) => {
    let imgUrl = "";
    await uploadFile(e)
      .then((res: any) => {
        imgUrl = res;
      })
      .catch((err: any) => {
        showToast("error", err.message);
      });
    onSelect(imgUrl || "");
  };

  return (
    <div className="relative">
      <ATMFileUploader
        size={size}
        label={label}
        required={required}
        placeholder={placeholder}
        onSelect={onSelectFilePicker}
        selectedFile={selectedFile}
        accept={accept}
        disabled={disabled}
        isLoading={isLoading}
      />

      {name && (
        <ErrorMessage name={name}>
          {(errMsg) => (
            <p className="font-poppins absolute text-[14px] text-start mt-0 text-red-500">
              {errMsg}
            </p>
          )}
        </ErrorMessage>
      )}
    </div>
  );
};

export default ATMFilePickerWrapper;
